const i = 2, n = (t, e = "", r = 2) => {
  const o = ["-", "", "+"][Math.sign(t) + 1], s = Math.abs(t).toFixed(r);
  return `${o}${e}${s}`;
}, a = (t) => `${n(t, " ")}`, c = (t) => `(${n(t)}%)`;
export {
  i as NUMBER_OF_DECIMALS,
  a as prettyPrintAbsoluteChange,
  n as prettyPrintNumber,
  c as prettyPrintRelativeChange
};
